export const TESTIDS = {
  // Header
  headerLogo: "header-logo",
  headerNav: "header-nav",
  headerNavLink: (slug) => `nav-link-${slug}`,
  headerCta: "header-cta-schedule-tour",
  headerMobileToggle: "header-mobile-toggle",
  headerMobileMenu: "header-mobile-menu",

  // Hero
  heroTitle: "hero-title",
  heroPrimaryCta: "hero-primary-cta",
  heroSecondaryCta: "hero-secondary-cta",

  // Availability
  availabilitySection: "availability-section",
  availabilityCard: (slug) => `availability-card-${slug}`,
  availabilityInquire: (slug) => `availability-inquire-${slug}`,

  // Spaces / cards
  spaceCard: (slug) => `space-card-${slug}`,
  spaceDetailHero: "space-detail-hero",

  // Inquiry form
  inquiryForm: "inquiry-form",
  inputFullName: "inquiry-full-name",
  inputCompany: "inquiry-company",
  inputEmail: "inquiry-email",
  inputPhone: "inquiry-phone",
  inputTeamSize: "inquiry-team-size",
  inputMoveInDate: "inquiry-move-in-date",
  inputOfficeType: "inquiry-office-type",
  inputNotes: "inquiry-notes",
  inquirySubmit: "inquiry-submit",
  inquirySuccess: "inquiry-success",
  inquiryError: "inquiry-error",

  // Contact panel
  contactPanel: "contact-panel",
  contactPanelCall: "contact-panel-call",
  contactPanelEmail: "contact-panel-email",

  // FAQ
  faqItem: (i) => `faq-item-${i}`,

  // Floating
  stickyTourBtn: "sticky-tour-btn",
  floatingContactBtn: "floating-contact-btn",
  floatingCallLink: "floating-call-link",

  // Footer
  footer: "site-footer",

  // Final CTA
  finalCta: "final-cta",
};
